import { z } from "zod";
import { DefaultValues } from "react-hook-form";
import { productAdjustmentSchema } from "./schemas/productAdjustmentSchema";
import { ProductAdjustment } from "@/shared/core-product-adjustments";

export const getDefaultValues = (
  productAdjustment?: ProductAdjustment | null,
  zoneId?: string,
): DefaultValues<z.infer<typeof productAdjustmentSchema>> => {
  return {
    zoneId: zoneId ?? "",
    storageId: productAdjustment?.storageId,
    productAdjustmentTypeId: productAdjustment?.productAdjustmentTypeId,
    description: productAdjustment?.description || "",
    products: productAdjustment
      ? productAdjustment.products.map((product) => ({
          data: product,
          id: product.id,
          amount: product.adjustmentProduct?.quantity || 0,
        }))
      : [],
  };
};
